/**
 * Extended ViewController template
 *
 * User: adic
 * Date: 4/21/13
 * Time: 9:54 AM
 */
define(function (require) {


    var VisitorInfoViewController = require('web-agent-viewControllers/VisitorInfoViewController');
    var WidgetViewController = require('web-agent-framework/WidgetViewController');


    var VisitorInfoWidget = WidgetViewController.extend({
        ControllerName: "VisitorInfoWidget",
        applicationType: 'VisitorInfoWidget',

        widgetIcon: "right_pane_button_profile",

        LPViewMap: {
            headerContainer: ".visitor_info_header",
            visitorSerialNumber: ".lpview_visitor_serial_number",
            visitorName: ".lpview_visitor_name"
        },

        initialize: function (constructorData) {
            this.tableName = constructorData.tableName;
            this.visitorId = constructorData.visitorId;
            this.createView({templateFile: "LP_visitor_info_header.html",
                hidden: true}); // TODO: See how to remove the header, it currently breaks the visitor info widget when removed.

            this.visitorInfoVC = new VisitorInfoViewController({
                onResize: constructorData.onResize,
                visitorId: this.visitorId,
                modelController: this.modelController,
                templateFile: "LP_visitor_info_table.html"
            });

            this.addViewController(this.visitorInfoVC);
        },

        events: function () {
            if (this.singleton) {
                this.viewEventsHandler.bindEvent({appName : this.tableName , UIEvent : this.viewEventsHandler.eventType.TABLE_WIDGETS_OPENED, callback: this.handleVisitorFocusChanged});
            }
        },

        render: function (resize) {
            if (this.visitorInfoVC) {
                this.visitorInfoVC.render(resize);
            }
        }
    });

    VisitorInfoWidget.prototype.handleVisitorFocusChanged = function (data) {
        if (!data.newValue || !data.newValue.eventData || !data.newValue.eventData.id) {
            return;
        }
        var visitorId = data.newValue.eventData.id;
        this.updateVisitorId(visitorId, 'visitorList.data.');

    };

    VisitorInfoWidget.prototype.updateVisitorId = function (visitorId, participantPath) {
        if (this.visitorId !== visitorId) {
            WidgetViewController.prototype.updateVisitorId.call(this, visitorId);
            this.visitorInfoVC.updateVisitorId(this.visitorId, participantPath);
        }
    };

    VisitorInfoWidget.prototype.setColorSchema = function (color) {
        if (this.colorSchema === color){return;}
        if (this.colorSchema) {
            this.removeClass(this.LPViewMap.headerContainer, this.colorSchema);
        }
        this.colorSchema = color;
        if (this.colorSchema) {
            this.addClass(this.LPViewMap.headerContainer, this.colorSchema);
        }
    };

    VisitorInfoWidget.prototype.handleTagChanged = function (data) {
        if (typeof data.newValue !== 'undefined') {
            this.setColorSchema(data.newValue);
        }
    };

    return VisitorInfoWidget;

});
